/** This file should NOT be included in the build */

export const MESSAGE_KEYS = {
    TO: ['STO.COMPONENTS.COMMON.TO', 'tot'],
    SHOW_MORE: ['STO.COMPONENTS.COMMON.SHOW_MORE', 'Toon meer'],
    SHOW_LESS: ['STO.COMPONENTS.COMMON.SHOW_LESS', 'Toon minder'],
    OPTIONAL: ['STO.COMPONENTS.COMMON.FORM.OPTIONAL', 'Optioneel'],
    ACTION_ADD: ['STO.COMPONENTS.COMMON.FORM.ADD', 'Toevoegen'],
    FILTERS_HIDE: ['STO.COMPONENTS.COMMON.FILTERS.HIDE', 'Filters verbergen'],
    FILTERS_SHOW: ['STO.COMPONENTS.COMMON.FILTERS.SHOW', 'Filters tonen'],
    FILTERS_RESET: ['STO.COMPONENTS.COMMON.FILTERS.RESET', 'Filters resetten'],
    TABLE_ACTIONS: ['STO.COMPONENTS.COMMON.TABLE.ACTIONS', 'Acties'],
    SYSTEM: ['STO.COMPONENTS.COMMON.SYSTEM', 'Systeem'],
    ALL: ['STO.COMPONENTS.COMMON.ALL', 'Alle'],
    FILTERS: ['STO.COMPONENTS.COMMON.FILTERS', 'Filters'],
    X_MORE: ['STO.COMPONENTS.COMMON.X_MORE', 'meer'],
}
